import axios from "axios";

export default {
    search: async (keyword) => {
        const { data } = await axios.get('/dispatcher/', {
            params: {
                keyword,
                action: 'get_clients_and_users_autocomplete'
            }
        })

        return data
    }
}
